import img01 from "../images/img-01.png";
import img02 from "../images/img-02.png";
import img03 from "../images/img-03.png";
import img04 from "../images/img-04.png";
import img05 from "../images/img-05.png";
import img06 from "../images/img-06.png";
import img07 from "../images/img-07.png";
import img08 from "../images/img-08.png";
import img09 from "../images/img-09.png";
import img10 from "../images/img-10.png";


import ava01 from "../images/ava-01.png";
import ava02 from "../images/ava-02.png";
import ava03 from "../images/ava-03.png";
import ava04 from "../images/ava-04.png";
import ava05 from "../images/ava-05.png";
import ava06 from "../images/ava-06.png";

export const NFT__DATA = [
  {
    id: "01",
    title: "BladeFox: The Cyber Samurai",
    desc: "BladeFox: The Cyber ​​Samurai is a unique NFT from the FoxVerse: Legends of the Future collection, featuring a samurai fox in bright cyberpunk neon colors. This character combines the traditions of ancient warriors with modern technology of the future. The fox has blue fur with with neon patterns that emphasize her cybernetic nature.She wears a purple cloak adorned with golden symbols that symbolize her affiliation with the ancient Cyber ​​Samurai Order.",
    imgUrl: img01,
    creator: "Kozhydlo Mark",
    creatorImg: ava01,
    currentBid: 0.0227431,
    buyUrl: "#",
  },

  {
    id: "02",
    title: "Lynx Strike",
    desc: "Lynx Strike is a vibrant and edgy NFT that captures the essence of urban wilderness. This digital artwork features a fierce lynx, standing tall in a hoodie emblazoned with mysterious symbols, blending the worlds of nature and street culture. The neon-pink and yellow color palette radiates energy, while the lynx's intense gaze suggests wisdom and power. Perfect for collectors who appreciate the intersection of wild spirit and modern style, this piece is a statement of bold individuality and untamed creativity.",
    imgUrl: img02,
    creator: "Kozhydlo Mark",
    creatorImg: ava02,
    currentBid: 0.0094763,
    buyUrl: "#",
  },

  {
    id: "03",
    title: "Samurai Lynx",
    desc: "Samurai Lynx is a striking NFT that merges the ferocity of a wild lynx with the discipline of a samurai warrior. Dressed in a vibrant, futuristic jacket and holding a sleek katana, this lynx embodies the spirit of honor and strength. The bold purple and orange hues of the artwork create a powerful contrast, emphasizing the lynxs piercing gaze and warrior stance. This piece is perfect for collectors who appreciate a blend of ancient tradition and modern flair, symbolizing the perfect balance between natures raw power and the precision of a samurai.",
    imgUrl: img03,
    creator: "Kozhydlo Mark",
    creatorImg: ava03,
    currentBid: 0.0151620,
    buyUrl: "#",
  },

  {
    id: "04",
    title: "Neon Prowler",
    desc: "Neon Prowler is a fierce and enigmatic figure in the digital world. With glowing yellow eyes that pierce through the night, this cybernetic feline warrior blends the raw power of nature with cutting-edge technology. Dressed in a vibrant purple jacket adorned with ancient symbols, Neon Prowler is always ready for action, wielding a sleek katana that glows with a soft, ethereal light. This NFT captures the essence of a futuristic guardian, combining the mystique of the wild with the relentless energy of the neon cityscape. Ideal for collectors who appreciate bold, eye-catching designs and the spirit of adventure",
    imgUrl: img04,
    creator: "Kozhydlo Mark",
    creatorImg: ava04,
    currentBid: 0.0075810,
    buyUrl: "#",
  },

  {
    id: "05",
    title: "Kitsune Guardian",
    desc: "Kitsune Guardian embodies the ancient spirit of the fox, a creature known for its wisdom and cunning. Draped in a beautifully detailed kimono with floral patterns, this mystical protector exudes a sense of calm and authority. With sharp, golden eyes and a poised stance, Kitsune Guardian carries twin katanas, symbolizing its readiness to defend and uphold the balance between worlds. The warm, orange hue of its fur harmonizes with the soft, glowing backdrop, creating an aura of serenity mixed with the power of tradition. Perfect for collectors who appreciate the fusion of cultural heritage with modern artistry",
    imgUrl: img05,
   creator: "Kozhydlo Mark",
    creatorImg: ava05,
    currentBid: 0.0075810,
    buyUrl: "#",
  },

  {
    id: "06",
    title: "Urban Kitsune",
    desc: "Urban Kitsune is the embodiment of modern mysticism, blending the ancient spirit of the fox with the pulse of the neon-lit city. Clad in a vibrant orange hoodie with a bold, symbolic emblem on its chest, this fox exudes confidence and street-smart prowess. Its piercing green eyes are filled with both wisdom and a hint of mischief, ready to outmaneuver any challenge. Armed with dual katanas, Urban Kitsune is a protector of the urban jungle, where tradition meets the cutting edge. This NFT is perfect for those who appreciate the blend of contemporary street culture with the timeless energy of mythical legends.",
    imgUrl: img06,
    creator: "Kozhydlo Mark",
    creatorImg: ava06,
    currentBid: 0.0095810,
    buyUrl: "#",
  },

  {
    id: "07",
    title: "Kitsune Ronin",
    desc: "Kitsune Ronin is a striking NFT that features a fierce fox warrior, blending traditional Japanese samurai aesthetics with the mythical spirit of the Kitsune. Dressed in an intricate blue kimono adorned with floral patterns, the fox stands confidently, holding dual katanas, ready for battle. Behind, a serene torii gate and cherry blossoms frame the scene, evoking the tranquil yet powerful essence of ancient Japan. This NFT captures the mysterious and cunning nature of the Kitsune, embodying both elegance and strength in a single, captivating image.",
    imgUrl: img07,
   creator: "Kozhydlo Mark",
    creatorImg: ava03,
    currentBid: 0.0105810,
    buyUrl: "#",
  },

  {
    id: "08",
    title: "Streetwise Kitsune",
    desc: "Streetwise Kitsune showcases a clever fox character dressed in trendy urban attire, perfectly blending with the lively cityscape around them. Sporting a teal jacket, matching cap, and bold yellow sneakers, this fox exudes confidence and style, symbolizing the cunning and adaptability of the Kitsune in a modern setting. The bustling street, filled with colorful graffiti and towering buildings, highlights the characters street-smart nature and readiness to navigate the challenges of city life. This NFT is a celebration of urban culture and the timeless, playful spirit of the fox, making it a standout piece in any collection.",
    imgUrl: img09,
    creator: "Kozhydlo Mark",
    creatorImg: ava04,
    currentBid: 0.0095410,
    buyUrl: "#",
  },

];

export const SELLER__DATA = [
  {
    id: "01",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Ryan Carder",
    sellerImg: ava01,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "02",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Trista Francis",
    sellerImg: ava02,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "03",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Ryan Carder",
    sellerImg: ava03,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "04",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Ryan Carder",
    sellerImg: ava04,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "05",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Trista Francis",
    sellerImg: ava05,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "06",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Trista Francis",
    sellerImg: ava06,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "01",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Ryan Carder",
    sellerImg: ava01,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "02",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Trista Francis",
    sellerImg: ava02,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "03",
    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",
    sellerName: "Ryan Carder",
    sellerImg: ava03,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "04",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Ryan Carder",
    sellerImg: ava04,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "05",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Trista Francis",
    sellerImg: ava05,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },

  {
    id: "06",

    desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Veniam adipisci cupiditate officia",

    sellerName: "Trista Francis",
    sellerImg: ava06,
    currentBid: 5.89,
    fbUrl: "#",
    instaUrl: "#",
    twitUrl: "#",
  },
];
